import React, { useState, useMemo, useEffect, useCallback } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AuthingButton, AuthingButtonArrow } from "../AuthingButton";
import { useNavigate, useHistory } from "react-router-dom";
import { getCookie } from "../../utils";

export const CardProduct = ({
  title,
  subtitle,
  contentList,
  bgimg,
  img,
  icon,
  type,
  mode = "light",
  subtitleMinHeight,
  exchange,
  style = {},
  widthPercent = 1,
  detailUrl,
  className: classNameT = "",
  fromTag,
  trial = false,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const nav = useNavigate();
  const className = classNames(classNameT, [
    "card-product",
    mode,
    type,
    bgimg ? "card-product-width-hasbgimg" : "card-product-width",
    "widthPercent" + widthPercent,
  ]);
  const innerHtml = useMemo(() => {
    return (
      <>
        {icon && (
          <div
            className={classNames({
              "card-product-icon": true,
              lock: exchange ? "lock" : "",
            })}
          >
            <img src={icon} alt="authing-icon" />
          </div>
        )}
        <div className="card-product-title">{title}</div>
        <div className="card-product-subtitle">{subtitle}</div>
        {contentList && (
          <div className="card-product-content-lists">
            {contentList.map((list) => (
              <div className="card-product-content-list">
                <span className="card-product-content-list-icon">
                  <img src={list.img} alt="" />
                </span>
                <div className="card-product-content-list-desc">
                  {list.value}
                </div>
              </div>
            ))}
          </div>
        )}
        <div
          className={classNames({
            "card-product-button-warp": true,
            lock: exchange ? "lock" : "",
          })}
        >
          {detailUrl && (
            <AuthingButton
              size="small"
              style={{ marginRight: 16 }}
              onClick={() => {
                if (!detailUrl) {
                  return;
                }
                window.open(detailUrl);
              }}
            >
              {t("common.button.detail")}
            </AuthingButton>
          )}
          {trial ? (
            <AuthingButtonArrow
              mode={mode === "dark" ? "color-white" : "color-blue"}
              onClick={() => {
                window.open(
                  " https://host.huiju.cool/page/2950744787608099153/43f5f5e1a2b148aa8e993c02f50e8b90"
                );
              }}
              style={{
                display: !detailUrl ? "block" : "",
                padding: !detailUrl ? 0 : "",
              }}
            >
              {t("common.button.trial-request")}
            </AuthingButtonArrow>
          ) : (
            <AuthingButtonArrow
              mode={mode === "dark" ? "color-white" : "color-blue"}
              onClick={() => {
                window.open(
                  fromTag
                    ? `https://www.authing.cn/authingform?fromTag=${fromTag}`
                    : "https://www.authing.cn/authingform"
                );
              }}
              style={{
                display: !detailUrl ? "block" : "",
                padding: !detailUrl ? 0 : "",
              }}
            >
              {t("common.button.consult")}
            </AuthingButtonArrow>
          )}
        </div>
        {img && (
          <div
            className="card-product-img"
            style={{
              backgroundImage: `url(${img})`,
            }}
          ></div>
        )}
      </>
    );
  }, [
    contentList,
    detailUrl,
    exchange,
    fromTag,
    icon,
    img,
    mode,
    subtitle,
    t,
    title,
    trial,
  ]);
  return (
    <div
      className={className}
      style={{
        ...style,
      }}
    >
      <div
        style={{
          backgroundImage: `url(${bgimg})`,
        }}
        className={classNames("card-product-bgimg", {
          "card-product-bgimg-animate": bgimg ? true : false,
        })}
      ></div>
      <div className="card-product-content-warp pc-show">{innerHtml}</div>
      <div
        className="card-product-content-warp mobile-show cursor"
        onClick={() => {
          if (detailUrl) {
            window.open(detailUrl);
          } else {
            window.open("https://www.authing.cn/customer");
          }
        }}
      >
        {innerHtml}
      </div>
    </div>
  );
};
